<p-table #pt [value]="users" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" [lazy]="true" (onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple"
	selectionMode="single" [(selection)]="user" dataKey="userId" (onRowSelect)="onRowSelect($event)" [loading]="loading" styleClass="p-datatable-striped">
	<ng-template pTemplate="caption"> 
		<div class="d-block text-end">
			<span>
				<!--clear filters-->
				<button pButton pRipple class="p-button-text"
					style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
					(click)="reloadPage()">Clear Filters</button>
				
				<!--add new-->
				<button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
					(click)="onOpenFormAdd()">New User +</button>
			</span>
		</div>
	</ng-template>

	<ng-template pTemplate="header">
		<tr>
			<th [pSortableColumn]="'userId'">UserId <p-sortIcon [field]="'userId'"></p-sortIcon>
			</th>
			<th [pSortableColumn]="'status'">Status <p-sortIcon [field]="'status'"></p-sortIcon>
			</th>
			<th [pSortableColumn]="'firstName'">First <p-sortIcon [field]="'firstName'"></p-sortIcon>
			</th>
			<th [pSortableColumn]="'lastName'">Last <p-sortIcon [field]="'lastName'"></p-sortIcon>
			</th>
			<th [pSortableColumn]="'email'">Email <p-sortIcon [field]="'email'"></p-sortIcon>
			</th>
			<th [pSortableColumn]="'lastLogin'">Last Login <p-sortIcon [field]="'lastLogin'"></p-sortIcon>
			</th>
		</tr>
		<tr>

			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'userId', 'in')"></th>
			<th>
				<p-multiSelect [options]="userStatusOptions" defaultLabel="Status" (onChange)="pt.filter($event.value, 'status', 'in')"></p-multiSelect>
			</th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'email', 'in')"></th>


		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-user>
		<tr [pSelectableRow]="user">
			<td>{{user.userId}}</td>
			<td>{{user.status}}</td>
			<td>{{user.firstName}}</td>
			<td>{{user.lastName}}</td>
			<td>{{user.email}}</td>
			<td>{{user.lastLogin}}</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
: recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>
